export default {
    "scalars": [
        1,
        4,
        5,
        6,
        9,
        11,
        13,
        14,
        16,
        18,
        25,
        26,
        27,
        29,
        30,
        31,
        35,
        36,
        42,
        43,
        44,
        51,
        58,
        63,
        66,
        68,
        69,
        73,
        74,
        78,
        83,
        86,
        99,
        110,
        111,
        112,
        118,
        140,
        141,
        142,
        143,
        149,
        153,
        163,
        164,
        172,
        175,
        184
    ],
    "types": {
        "Query": {
            "Page": [
                2,
                {
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "Media": [
                23,
                {
                    "id": [
                        1
                    ],
                    "idMal": [
                        1
                    ],
                    "startDate": [
                        110
                    ],
                    "endDate": [
                        110
                    ],
                    "season": [
                        29
                    ],
                    "seasonYear": [
                        1
                    ],
                    "type": [
                        25
                    ],
                    "format": [
                        26
                    ],
                    "status": [
                        27
                    ],
                    "episodes": [
                        1
                    ],
                    "duration": [
                        1
                    ],
                    "chapters": [
                        1
                    ],
                    "volumes": [
                        1
                    ],
                    "isAdult": [
                        4
                    ],
                    "genre": [
                        5
                    ],
                    "tag": [
                        5
                    ],
                    "minimumTagRank": [
                        1
                    ],
                    "tagCategory": [
                        5
                    ],
                    "onList": [
                        4
                    ],
                    "licensedBy": [
                        5
                    ],
                    "licensedById": [
                        1
                    ],
                    "averageScore": [
                        1
                    ],
                    "popularity": [
                        1
                    ],
                    "source": [
                        31
                    ],
                    "countryOfOrigin": [
                        30
                    ],
                    "isLicensed": [
                        4
                    ],
                    "search": [
                        5
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "idMal_not": [
                        1
                    ],
                    "idMal_in": [
                        1,
                        "[Int]"
                    ],
                    "idMal_not_in": [
                        1,
                        "[Int]"
                    ],
                    "startDate_greater": [
                        110
                    ],
                    "startDate_lesser": [
                        110
                    ],
                    "startDate_like": [
                        5
                    ],
                    "endDate_greater": [
                        110
                    ],
                    "endDate_lesser": [
                        110
                    ],
                    "endDate_like": [
                        5
                    ],
                    "format_in": [
                        26,
                        "[MediaFormat]"
                    ],
                    "format_not": [
                        26
                    ],
                    "format_not_in": [
                        26,
                        "[MediaFormat]"
                    ],
                    "status_in": [
                        27,
                        "[MediaStatus]"
                    ],
                    "status_not": [
                        27
                    ],
                    "status_not_in": [
                        27,
                        "[MediaStatus]"
                    ],
                    "episodes_greater": [
                        1
                    ],
                    "episodes_lesser": [
                        1
                    ],
                    "duration_greater": [
                        1
                    ],
                    "duration_lesser": [
                        1
                    ],
                    "chapters_greater": [
                        1
                    ],
                    "chapters_lesser": [
                        1
                    ],
                    "volumes_greater": [
                        1
                    ],
                    "volumes_lesser": [
                        1
                    ],
                    "genre_in": [
                        5,
                        "[String]"
                    ],
                    "genre_not_in": [
                        5,
                        "[String]"
                    ],
                    "tag_in": [
                        5,
                        "[String]"
                    ],
                    "tag_not_in": [
                        5,
                        "[String]"
                    ],
                    "tagCategory_in": [
                        5,
                        "[String]"
                    ],
                    "tagCategory_not_in": [
                        5,
                        "[String]"
                    ],
                    "licensedBy_in": [
                        5,
                        "[String]"
                    ],
                    "licensedById_in": [
                        1,
                        "[Int]"
                    ],
                    "averageScore_not": [
                        1
                    ],
                    "averageScore_greater": [
                        1
                    ],
                    "averageScore_lesser": [
                        1
                    ],
                    "popularity_not": [
                        1
                    ],
                    "popularity_greater": [
                        1
                    ],
                    "popularity_lesser": [
                        1
                    ],
                    "source_in": [
                        31,
                        "[MediaSource]"
                    ],
                    "sort": [
                        42,
                        "[MediaSort]"
                    ]
                }
            ],
            "MediaTrend": [
                61,
                {
                    "mediaId": [
                        1
                    ],
                    "date": [
                        1
                    ],
                    "trending": [
                        1
                    ],
                    "averageScore": [
                        1
                    ],
                    "popularity": [
                        1
                    ],
                    "episode": [
                        1
                    ],
                    "releasing": [
                        4
                    ],
                    "mediaId_not": [
                        1
                    ],
                    "mediaId_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "date_greater": [
                        1
                    ],
                    "date_lesser": [
                        1
                    ],
                    "trending_greater": [
                        1
                    ],
                    "trending_lesser": [
                        1
                    ],
                    "trending_not": [
                        1
                    ],
                    "averageScore_greater": [
                        1
                    ],
                    "averageScore_lesser": [
                        1
                    ],
                    "averageScore_not": [
                        1
                    ],
                    "popularity_greater": [
                        1
                    ],
                    "popularity_lesser": [
                        1
                    ],
                    "popularity_not": [
                        1
                    ],
                    "episode_greater": [
                        1
                    ],
                    "episode_lesser": [
                        1
                    ],
                    "episode_not": [
                        1
                    ],
                    "sort": [
                        58,
                        "[MediaTrendSort]"
                    ]
                }
            ],
            "AiringSchedule": [
                55,
                {
                    "id": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "episode": [
                        1
                    ],
                    "airingAt": [
                        1
                    ],
                    "notYetAired": [
                        4
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not": [
                        1
                    ],
                    "mediaId_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "episode_not": [
                        1
                    ],
                    "episode_in": [
                        1,
                        "[Int]"
                    ],
                    "episode_not_in": [
                        1,
                        "[Int]"
                    ],
                    "episode_greater": [
                        1
                    ],
                    "episode_lesser": [
                        1
                    ],
                    "airingAt_greater": [
                        1
                    ],
                    "airingAt_lesser": [
                        1
                    ],
                    "sort": [
                        112,
                        "[AiringSort]"
                    ]
                }
            ],
            "Character": [
                39,
                {
                    "id": [
                        1
                    ],
                    "isBirthday": [
                        4
                    ],
                    "search": [
                        5
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "sort": [
                        35,
                        "[CharacterSort]"
                    ]
                }
            ],
            "Staff": [
                45,
                {
                    "id": [
                        1
                    ],
                    "isBirthday": [
                        4
                    ],
                    "search": [
                        5
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "sort": [
                        44,
                        "[StaffSort]"
                    ]
                }
            ],
            "MediaList": [
                67,
                {
                    "id": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "userName": [
                        5
                    ],
                    "type": [
                        25
                    ],
                    "status": [
                        16
                    ],
                    "mediaId": [
                        1
                    ],
                    "isFollowing": [
                        4
                    ],
                    "notes": [
                        5
                    ],
                    "startedAt": [
                        110
                    ],
                    "completedAt": [
                        110
                    ],
                    "compareWithAuthList": [
                        4
                    ],
                    "userId_in": [
                        1,
                        "[Int]"
                    ],
                    "status_in": [
                        16,
                        "[MediaListStatus]"
                    ],
                    "status_not_in": [
                        16,
                        "[MediaListStatus]"
                    ],
                    "status_not": [
                        16
                    ],
                    "mediaId_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "notes_like": [
                        5
                    ],
                    "startedAt_greater": [
                        110
                    ],
                    "startedAt_lesser": [
                        110
                    ],
                    "startedAt_like": [
                        5
                    ],
                    "completedAt_greater": [
                        110
                    ],
                    "completedAt_lesser": [
                        110
                    ],
                    "completedAt_like": [
                        5
                    ],
                    "sort": [
                        111,
                        "[MediaListSort]"
                    ]
                }
            ],
            "MediaListCollection": [
                144,
                {
                    "userId": [
                        1
                    ],
                    "userName": [
                        5
                    ],
                    "type": [
                        25
                    ],
                    "status": [
                        16
                    ],
                    "notes": [
                        5
                    ],
                    "startedAt": [
                        110
                    ],
                    "completedAt": [
                        110
                    ],
                    "forceSingleCompletedList": [
                        4
                    ],
                    "chunk": [
                        1
                    ],
                    "perChunk": [
                        1
                    ],
                    "status_in": [
                        16,
                        "[MediaListStatus]"
                    ],
                    "status_not_in": [
                        16,
                        "[MediaListStatus]"
                    ],
                    "status_not": [
                        16
                    ],
                    "notes_like": [
                        5
                    ],
                    "startedAt_greater": [
                        110
                    ],
                    "startedAt_lesser": [
                        110
                    ],
                    "startedAt_like": [
                        5
                    ],
                    "completedAt_greater": [
                        110
                    ],
                    "completedAt_lesser": [
                        110
                    ],
                    "completedAt_like": [
                        5
                    ],
                    "sort": [
                        111,
                        "[MediaListSort]"
                    ]
                }
            ],
            "GenreCollection": [
                5
            ],
            "MediaTagCollection": [
                34,
                {
                    "status": [
                        1
                    ]
                }
            ],
            "User": [
                7,
                {
                    "id": [
                        1
                    ],
                    "name": [
                        5
                    ],
                    "isModerator": [
                        4
                    ],
                    "search": [
                        5
                    ],
                    "sort": [
                        6,
                        "[UserSort]"
                    ]
                }
            ],
            "Viewer": [
                7
            ],
            "Notification": [
                113,
                {
                    "type": [
                        13
                    ],
                    "resetNotificationCount": [
                        4
                    ],
                    "type_in": [
                        13,
                        "[NotificationType]"
                    ]
                }
            ],
            "Studio": [
                54,
                {
                    "id": [
                        1
                    ],
                    "search": [
                        5
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "sort": [
                        51,
                        "[StudioSort]"
                    ]
                }
            ],
            "Review": [
                72,
                {
                    "id": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "mediaType": [
                        25
                    ],
                    "sort": [
                        69,
                        "[ReviewSort]"
                    ]
                }
            ],
            "Activity": [
                121,
                {
                    "id": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "messengerId": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "type": [
                        118
                    ],
                    "isFollowing": [
                        4
                    ],
                    "hasReplies": [
                        4
                    ],
                    "hasRepliesOrTypeText": [
                        4
                    ],
                    "createdAt": [
                        1
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "userId_not": [
                        1
                    ],
                    "userId_in": [
                        1,
                        "[Int]"
                    ],
                    "userId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "messengerId_not": [
                        1
                    ],
                    "messengerId_in": [
                        1,
                        "[Int]"
                    ],
                    "messengerId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not": [
                        1
                    ],
                    "mediaId_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "type_not": [
                        118
                    ],
                    "type_in": [
                        118,
                        "[ActivityType]"
                    ],
                    "type_not_in": [
                        118,
                        "[ActivityType]"
                    ],
                    "createdAt_greater": [
                        1
                    ],
                    "createdAt_lesser": [
                        1
                    ],
                    "sort": [
                        140,
                        "[ActivitySort]"
                    ]
                }
            ],
            "ActivityReply": [
                119,
                {
                    "id": [
                        1
                    ],
                    "activityId": [
                        1
                    ]
                }
            ],
            "Following": [
                7,
                {
                    "userId": [
                        1,
                        "Int!"
                    ],
                    "sort": [
                        6,
                        "[UserSort]"
                    ]
                }
            ],
            "Follower": [
                7,
                {
                    "userId": [
                        1,
                        "Int!"
                    ],
                    "sort": [
                        6,
                        "[UserSort]"
                    ]
                }
            ],
            "Thread": [
                129,
                {
                    "id": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "replyUserId": [
                        1
                    ],
                    "subscribed": [
                        4
                    ],
                    "categoryId": [
                        1
                    ],
                    "mediaCategoryId": [
                        1
                    ],
                    "search": [
                        5
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "sort": [
                        141,
                        "[ThreadSort]"
                    ]
                }
            ],
            "ThreadComment": [
                131,
                {
                    "id": [
                        1
                    ],
                    "threadId": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "sort": [
                        142,
                        "[ThreadCommentSort]"
                    ]
                }
            ],
            "Recommendation": [
                77,
                {
                    "id": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "mediaRecommendationId": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "rating": [
                        1
                    ],
                    "onList": [
                        4
                    ],
                    "rating_greater": [
                        1
                    ],
                    "rating_lesser": [
                        1
                    ],
                    "sort": [
                        74,
                        "[RecommendationSort]"
                    ]
                }
            ],
            "Like": [
                7,
                {
                    "likeableId": [
                        1
                    ],
                    "type": [
                        143
                    ]
                }
            ],
            "Markdown": [
                146,
                {
                    "markdown": [
                        5,
                        "String!"
                    ]
                }
            ],
            "AniChartUser": [
                147
            ],
            "SiteStatistics": [
                148
            ],
            "ExternalLinkSourceCollection": [
                62,
                {
                    "id": [
                        1
                    ],
                    "type": [
                        63
                    ],
                    "mediaType": [
                        153
                    ]
                }
            ],
            "__typename": [
                5
            ]
        },
        "Int": {},
        "Page": {
            "pageInfo": [
                3
            ],
            "users": [
                7,
                {
                    "id": [
                        1
                    ],
                    "name": [
                        5
                    ],
                    "isModerator": [
                        4
                    ],
                    "search": [
                        5
                    ],
                    "sort": [
                        6,
                        "[UserSort]"
                    ]
                }
            ],
            "media": [
                23,
                {
                    "id": [
                        1
                    ],
                    "idMal": [
                        1
                    ],
                    "startDate": [
                        110
                    ],
                    "endDate": [
                        110
                    ],
                    "season": [
                        29
                    ],
                    "seasonYear": [
                        1
                    ],
                    "type": [
                        25
                    ],
                    "format": [
                        26
                    ],
                    "status": [
                        27
                    ],
                    "episodes": [
                        1
                    ],
                    "duration": [
                        1
                    ],
                    "chapters": [
                        1
                    ],
                    "volumes": [
                        1
                    ],
                    "isAdult": [
                        4
                    ],
                    "genre": [
                        5
                    ],
                    "tag": [
                        5
                    ],
                    "minimumTagRank": [
                        1
                    ],
                    "tagCategory": [
                        5
                    ],
                    "onList": [
                        4
                    ],
                    "licensedBy": [
                        5
                    ],
                    "licensedById": [
                        1
                    ],
                    "averageScore": [
                        1
                    ],
                    "popularity": [
                        1
                    ],
                    "source": [
                        31
                    ],
                    "countryOfOrigin": [
                        30
                    ],
                    "isLicensed": [
                        4
                    ],
                    "search": [
                        5
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "idMal_not": [
                        1
                    ],
                    "idMal_in": [
                        1,
                        "[Int]"
                    ],
                    "idMal_not_in": [
                        1,
                        "[Int]"
                    ],
                    "startDate_greater": [
                        110
                    ],
                    "startDate_lesser": [
                        110
                    ],
                    "startDate_like": [
                        5
                    ],
                    "endDate_greater": [
                        110
                    ],
                    "endDate_lesser": [
                        110
                    ],
                    "endDate_like": [
                        5
                    ],
                    "format_in": [
                        26,
                        "[MediaFormat]"
                    ],
                    "format_not": [
                        26
                    ],
                    "format_not_in": [
                        26,
                        "[MediaFormat]"
                    ],
                    "status_in": [
                        27,
                        "[MediaStatus]"
                    ],
                    "status_not": [
                        27
                    ],
                    "status_not_in": [
                        27,
                        "[MediaStatus]"
                    ],
                    "episodes_greater": [
                        1
                    ],
                    "episodes_lesser": [
                        1
                    ],
                    "duration_greater": [
                        1
                    ],
                    "duration_lesser": [
                        1
                    ],
                    "chapters_greater": [
                        1
                    ],
                    "chapters_lesser": [
                        1
                    ],
                    "volumes_greater": [
                        1
                    ],
                    "volumes_lesser": [
                        1
                    ],
                    "genre_in": [
                        5,
                        "[String]"
                    ],
                    "genre_not_in": [
                        5,
                        "[String]"
                    ],
                    "tag_in": [
                        5,
                        "[String]"
                    ],
                    "tag_not_in": [
                        5,
                        "[String]"
                    ],
                    "tagCategory_in": [
                        5,
                        "[String]"
                    ],
                    "tagCategory_not_in": [
                        5,
                        "[String]"
                    ],
                    "licensedBy_in": [
                        5,
                        "[String]"
                    ],
                    "licensedById_in": [
                        1,
                        "[Int]"
                    ],
                    "averageScore_not": [
                        1
                    ],
                    "averageScore_greater": [
                        1
                    ],
                    "averageScore_lesser": [
                        1
                    ],
                    "popularity_not": [
                        1
                    ],
                    "popularity_greater": [
                        1
                    ],
                    "popularity_lesser": [
                        1
                    ],
                    "source_in": [
                        31,
                        "[MediaSource]"
                    ],
                    "sort": [
                        42,
                        "[MediaSort]"
                    ]
                }
            ],
            "characters": [
                39,
                {
                    "id": [
                        1
                    ],
                    "isBirthday": [
                        4
                    ],
                    "search": [
                        5
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "sort": [
                        35,
                        "[CharacterSort]"
                    ]
                }
            ],
            "staff": [
                45,
                {
                    "id": [
                        1
                    ],
                    "isBirthday": [
                        4
                    ],
                    "search": [
                        5
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "sort": [
                        44,
                        "[StaffSort]"
                    ]
                }
            ],
            "studios": [
                54,
                {
                    "id": [
                        1
                    ],
                    "search": [
                        5
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "sort": [
                        51,
                        "[StudioSort]"
                    ]
                }
            ],
            "mediaList": [
                67,
                {
                    "id": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "userName": [
                        5
                    ],
                    "type": [
                        25
                    ],
                    "status": [
                        16
                    ],
                    "mediaId": [
                        1
                    ],
                    "isFollowing": [
                        4
                    ],
                    "notes": [
                        5
                    ],
                    "startedAt": [
                        110
                    ],
                    "completedAt": [
                        110
                    ],
                    "compareWithAuthList": [
                        4
                    ],
                    "userId_in": [
                        1,
                        "[Int]"
                    ],
                    "status_in": [
                        16,
                        "[MediaListStatus]"
                    ],
                    "status_not_in": [
                        16,
                        "[MediaListStatus]"
                    ],
                    "status_not": [
                        16
                    ],
                    "mediaId_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "notes_like": [
                        5
                    ],
                    "startedAt_greater": [
                        110
                    ],
                    "startedAt_lesser": [
                        110
                    ],
                    "startedAt_like": [
                        5
                    ],
                    "completedAt_greater": [
                        110
                    ],
                    "completedAt_lesser": [
                        110
                    ],
                    "completedAt_like": [
                        5
                    ],
                    "sort": [
                        111,
                        "[MediaListSort]"
                    ]
                }
            ],
            "airingSchedules": [
                55,
                {
                    "id": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "episode": [
                        1
                    ],
                    "airingAt": [
                        1
                    ],
                    "notYetAired": [
                        4
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not": [
                        1
                    ],
                    "mediaId_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "episode_not": [
                        1
                    ],
                    "episode_in": [
                        1,
                        "[Int]"
                    ],
                    "episode_not_in": [
                        1,
                        "[Int]"
                    ],
                    "episode_greater": [
                        1
                    ],
                    "episode_lesser": [
                        1
                    ],
                    "airingAt_greater": [
                        1
                    ],
                    "airingAt_lesser": [
                        1
                    ],
                    "sort": [
                        112,
                        "[AiringSort]"
                    ]
                }
            ],
            "mediaTrends": [
                61,
                {
                    "mediaId": [
                        1
                    ],
                    "date": [
                        1
                    ],
                    "trending": [
                        1
                    ],
                    "averageScore": [
                        1
                    ],
                    "popularity": [
                        1
                    ],
                    "episode": [
                        1
                    ],
                    "releasing": [
                        4
                    ],
                    "mediaId_not": [
                        1
                    ],
                    "mediaId_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "date_greater": [
                        1
                    ],
                    "date_lesser": [
                        1
                    ],
                    "trending_greater": [
                        1
                    ],
                    "trending_lesser": [
                        1
                    ],
                    "trending_not": [
                        1
                    ],
                    "averageScore_greater": [
                        1
                    ],
                    "averageScore_lesser": [
                        1
                    ],
                    "averageScore_not": [
                        1
                    ],
                    "popularity_greater": [
                        1
                    ],
                    "popularity_lesser": [
                        1
                    ],
                    "popularity_not": [
                        1
                    ],
                    "episode_greater": [
                        1
                    ],
                    "episode_lesser": [
                        1
                    ],
                    "episode_not": [
                        1
                    ],
                    "sort": [
                        58,
                        "[MediaTrendSort]"
                    ]
                }
            ],
            "notifications": [
                113,
                {
                    "type": [
                        13
                    ],
                    "resetNotificationCount": [
                        4
                    ],
                    "type_in": [
                        13,
                        "[NotificationType]"
                    ]
                }
            ],
            "followers": [
                7,
                {
                    "userId": [
                        1,
                        "Int!"
                    ],
                    "sort": [
                        6,
                        "[UserSort]"
                    ]
                }
            ],
            "following": [
                7,
                {
                    "userId": [
                        1,
                        "Int!"
                    ],
                    "sort": [
                        6,
                        "[UserSort]"
                    ]
                }
            ],
            "activities": [
                121,
                {
                    "id": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "messengerId": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "type": [
                        118
                    ],
                    "isFollowing": [
                        4
                    ],
                    "hasReplies": [
                        4
                    ],
                    "hasRepliesOrTypeText": [
                        4
                    ],
                    "createdAt": [
                        1
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "userId_not": [
                        1
                    ],
                    "userId_in": [
                        1,
                        "[Int]"
                    ],
                    "userId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "messengerId_not": [
                        1
                    ],
                    "messengerId_in": [
                        1,
                        "[Int]"
                    ],
                    "messengerId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not": [
                        1
                    ],
                    "mediaId_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "type_not": [
                        118
                    ],
                    "type_in": [
                        118,
                        "[ActivityType]"
                    ],
                    "type_not_in": [
                        118,
                        "[ActivityType]"
                    ],
                    "createdAt_greater": [
                        1
                    ],
                    "createdAt_lesser": [
                        1
                    ],
                    "sort": [
                        140,
                        "[ActivitySort]"
                    ]
                }
            ],
            "activityReplies": [
                119,
                {
                    "id": [
                        1
                    ],
                    "activityId": [
                        1
                    ]
                }
            ],
            "threads": [
                129,
                {
                    "id": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "replyUserId": [
                        1
                    ],
                    "subscribed": [
                        4
                    ],
                    "categoryId": [
                        1
                    ],
                    "mediaCategoryId": [
                        1
                    ],
                    "search": [
                        5
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "sort": [
                        141,
                        "[ThreadSort]"
                    ]
                }
            ],
            "threadComments": [
                131,
                {
                    "id": [
                        1
                    ],
                    "threadId": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "sort": [
                        142,
                        "[ThreadCommentSort]"
                    ]
                }
            ],
            "reviews": [
                72,
                {
                    "id": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "mediaType": [
                        25
                    ],
                    "sort": [
                        69,
                        "[ReviewSort]"
                    ]
                }
            ],
            "recommendations": [
                77,
                {
                    "id": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "mediaRecommendationId": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "rating": [
                        1
                    ],
                    "onList": [
                        4
                    ],
                    "rating_greater": [
                        1
                    ],
                    "rating_lesser": [
                        1
                    ],
                    "sort": [
                        74,
                        "[RecommendationSort]"
                    ]
                }
            ],
            "likes": [
                7,
                {
                    "likeableId": [
                        1
                    ],
                    "type": [
                        143
                    ]
                }
            ],
            "__typename": [
                5
            ]
        },
        "PageInfo": {
            "total": [
                1
            ],
            "perPage": [
                1
            ],
            "currentPage": [
                1
            ],
            "lastPage": [
                1
            ],
            "hasNextPage": [
                4
            ],
            "__typename": [
                5
            ]
        },
        "Boolean": {},
        "String": {},
        "UserSort": {},
        "User": {
            "id": [
                1
            ],
            "name": [
                5
            ],
            "about": [
                5,
                {
                    "asHtml": [
                        4
                    ]
                }
            ],
            "avatar": [
                8
            ],
            "bannerImage": [
                5
            ],
            "isFollowing": [
                4
            ],
            "isFollower": [
                4
            ],
            "isBlocked": [
                4
            ],
            "bans": [
                9
            ],
            "options": [
                10
            ],
            "mediaListOptions": [
                17
            ],
            "favourites": [
                20,
                {
                    "page": [
                        1
                    ]
                }
            ],
            "statistics": [
                84
            ],
            "unreadNotificationCount": [
                1
            ],
            "siteUrl": [
                5
            ],
            "donatorTier": [
                1
            ],
            "donatorBadge": [
                5
            ],
            "moderatorRoles": [
                99
            ],
            "createdAt": [
                1
            ],
            "updatedAt": [
                1
            ],
            "stats": [
                100
            ],
            "moderatorStatus": [
                5
            ],
            "previousNames": [
                109
            ],
            "__typename": [
                5
            ]
        },
        "UserAvatar": {
            "large": [
                5
            ],
            "medium": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "Json": {},
        "UserOptions": {
            "titleLanguage": [
                11
            ],
            "displayAdultContent": [
                4
            ],
            "airingNotifications": [
                4
            ],
            "profileColor": [
                5
            ],
            "notificationOptions": [
                12
            ],
            "timezone": [
                5
            ],
            "activityMergeTime": [
                1
            ],
            "staffNameLanguage": [
                14
            ],
            "restrictMessagesToFollowing": [
                4
            ],
            "disabledListActivity": [
                15
            ],
            "__typename": [
                5
            ]
        },
        "UserTitleLanguage": {},
        "NotificationOption": {
            "type": [
                13
            ],
            "enabled": [
                4
            ],
            "__typename": [
                5
            ]
        },
        "NotificationType": {},
        "UserStaffNameLanguage": {},
        "ListActivityOption": {
            "disabled": [
                4
            ],
            "type": [
                16
            ],
            "__typename": [
                5
            ]
        },
        "MediaListStatus": {},
        "MediaListOptions": {
            "scoreFormat": [
                18
            ],
            "rowOrder": [
                5
            ],
            "useLegacyLists": [
                4
            ],
            "animeList": [
                19
            ],
            "mangaList": [
                19
            ],
            "sharedTheme": [
                9
            ],
            "sharedThemeEnabled": [
                4
            ],
            "__typename": [
                5
            ]
        },
        "ScoreFormat": {},
        "MediaListTypeOptions": {
            "sectionOrder": [
                5
            ],
            "splitCompletedSectionByFormat": [
                4
            ],
            "theme": [
                9
            ],
            "customLists": [
                5
            ],
            "advancedScoring": [
                5
            ],
            "advancedScoringEnabled": [
                4
            ],
            "__typename": [
                5
            ]
        },
        "Favourites": {
            "anime": [
                21,
                {
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "manga": [
                21,
                {
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "characters": [
                37,
                {
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "staff": [
                49,
                {
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "studios": [
                52,
                {
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "__typename": [
                5
            ]
        },
        "MediaConnection": {
            "edges": [
                22
            ],
            "nodes": [
                23
            ],
            "pageInfo": [
                3
            ],
            "__typename": [
                5
            ]
        },
        "MediaEdge": {
            "node": [
                23
            ],
            "id": [
                1
            ],
            "relationType": [
                83,
                {
                    "version": [
                        1
                    ]
                }
            ],
            "isMainStudio": [
                4
            ],
            "characters": [
                39
            ],
            "characterRole": [
                36
            ],
            "characterName": [
                5
            ],
            "roleNotes": [
                5
            ],
            "dubGroup": [
                5
            ],
            "staffRole": [
                5
            ],
            "voiceActors": [
                45,
                {
                    "language": [
                        43
                    ],
                    "sort": [
                        44,
                        "[StaffSort]"
                    ]
                }
            ],
            "voiceActorRoles": [
                48,
                {
                    "language": [
                        43
                    ],
                    "sort": [
                        44,
                        "[StaffSort]"
                    ]
                }
            ],
            "favouriteOrder": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "Media": {
            "id": [
                1
            ],
            "idMal": [
                1
            ],
            "title": [
                24
            ],
            "type": [
                25
            ],
            "format": [
                26
            ],
            "status": [
                27,
                {
                    "version": [
                        1
                    ]
                }
            ],
            "description": [
                5,
                {
                    "asHtml": [
                        4
                    ]
                }
            ],
            "startDate": [
                28
            ],
            "endDate": [
                28
            ],
            "season": [
                29
            ],
            "seasonYear": [
                1
            ],
            "seasonInt": [
                1
            ],
            "episodes": [
                1
            ],
            "duration": [
                1
            ],
            "chapters": [
                1
            ],
            "volumes": [
                1
            ],
            "countryOfOrigin": [
                30
            ],
            "isLicensed": [
                4
            ],
            "source": [
                31,
                {
                    "version": [
                        1
                    ]
                }
            ],
            "hashtag": [
                5
            ],
            "trailer": [
                32
            ],
            "updatedAt": [
                1
            ],
            "coverImage": [
                33
            ],
            "bannerImage": [
                5
            ],
            "genres": [
                5
            ],
            "synonyms": [
                5
            ],
            "averageScore": [
                1
            ],
            "meanScore": [
                1
            ],
            "popularity": [
                1
            ],
            "isLocked": [
                4
            ],
            "trending": [
                1
            ],
            "favourites": [
                1
            ],
            "tags": [
                34
            ],
            "relations": [
                21
            ],
            "characters": [
                37,
                {
                    "sort": [
                        35,
                        "[CharacterSort]"
                    ],
                    "role": [
                        36
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "staff": [
                49,
                {
                    "sort": [
                        44,
                        "[StaffSort]"
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "studios": [
                52,
                {
                    "sort": [
                        51,
                        "[StudioSort]"
                    ],
                    "isMain": [
                        4
                    ]
                }
            ],
            "isFavourite": [
                4
            ],
            "isFavouriteBlocked": [
                4
            ],
            "isAdult": [
                4
            ],
            "nextAiringEpisode": [
                55
            ],
            "airingSchedule": [
                56,
                {
                    "notYetAired": [
                        4
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "trends": [
                59,
                {
                    "sort": [
                        58,
                        "[MediaTrendSort]"
                    ],
                    "releasing": [
                        4
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "externalLinks": [
                62
            ],
            "streamingEpisodes": [
                64
            ],
            "rankings": [
                65
            ],
            "mediaListEntry": [
                67
            ],
            "reviews": [
                70,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        69,
                        "[ReviewSort]"
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "recommendations": [
                75,
                {
                    "sort": [
                        74,
                        "[RecommendationSort]"
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "stats": [
                79
            ],
            "siteUrl": [
                5
            ],
            "autoCreateForumThread": [
                4
            ],
            "isRecommendationBlocked": [
                4
            ],
            "isReviewBlocked": [
                4
            ],
            "modNotes": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "MediaTitle": {
            "romaji": [
                5,
                {
                    "stylised": [
                        4
                    ]
                }
            ],
            "english": [
                5,
                {
                    "stylised": [
                        4
                    ]
                }
            ],
            "native": [
                5,
                {
                    "stylised": [
                        4
                    ]
                }
            ],
            "userPreferred": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "MediaType": {},
        "MediaFormat": {},
        "MediaStatus": {},
        "FuzzyDate": {
            "year": [
                1
            ],
            "month": [
                1
            ],
            "day": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "MediaSeason": {},
        "CountryCode": {},
        "MediaSource": {},
        "MediaTrailer": {
            "id": [
                5
            ],
            "site": [
                5
            ],
            "thumbnail": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "MediaCoverImage": {
            "extraLarge": [
                5
            ],
            "large": [
                5
            ],
            "medium": [
                5
            ],
            "color": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "MediaTag": {
            "id": [
                1
            ],
            "name": [
                5
            ],
            "description": [
                5
            ],
            "category": [
                5
            ],
            "rank": [
                1
            ],
            "isGeneralSpoiler": [
                4
            ],
            "isMediaSpoiler": [
                4
            ],
            "isAdult": [
                4
            ],
            "userId": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "CharacterSort": {},
        "CharacterRole": {},
        "CharacterConnection": {
            "edges": [
                38
            ],
            "nodes": [
                39
            ],
            "pageInfo": [
                3
            ],
            "__typename": [
                5
            ]
        },
        "CharacterEdge": {
            "node": [
                39
            ],
            "id": [
                1
            ],
            "role": [
                36
            ],
            "name": [
                5
            ],
            "voiceActors": [
                45,
                {
                    "language": [
                        43
                    ],
                    "sort": [
                        44,
                        "[StaffSort]"
                    ]
                }
            ],
            "voiceActorRoles": [
                48,
                {
                    "language": [
                        43
                    ],
                    "sort": [
                        44,
                        "[StaffSort]"
                    ]
                }
            ],
            "media": [
                23
            ],
            "favouriteOrder": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "Character": {
            "id": [
                1
            ],
            "name": [
                40
            ],
            "image": [
                41
            ],
            "description": [
                5,
                {
                    "asHtml": [
                        4
                    ]
                }
            ],
            "gender": [
                5
            ],
            "dateOfBirth": [
                28
            ],
            "age": [
                5
            ],
            "bloodType": [
                5
            ],
            "isFavourite": [
                4
            ],
            "isFavouriteBlocked": [
                4
            ],
            "siteUrl": [
                5
            ],
            "media": [
                21,
                {
                    "sort": [
                        42,
                        "[MediaSort]"
                    ],
                    "type": [
                        25
                    ],
                    "onList": [
                        4
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "updatedAt": [
                1
            ],
            "favourites": [
                1
            ],
            "modNotes": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "CharacterName": {
            "first": [
                5
            ],
            "middle": [
                5
            ],
            "last": [
                5
            ],
            "full": [
                5
            ],
            "native": [
                5
            ],
            "alternative": [
                5
            ],
            "alternativeSpoiler": [
                5
            ],
            "userPreferred": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "CharacterImage": {
            "large": [
                5
            ],
            "medium": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "MediaSort": {},
        "StaffLanguage": {},
        "StaffSort": {},
        "Staff": {
            "id": [
                1
            ],
            "name": [
                46
            ],
            "language": [
                43
            ],
            "languageV2": [
                5
            ],
            "image": [
                47
            ],
            "description": [
                5,
                {
                    "asHtml": [
                        4
                    ]
                }
            ],
            "primaryOccupations": [
                5
            ],
            "gender": [
                5
            ],
            "dateOfBirth": [
                28
            ],
            "dateOfDeath": [
                28
            ],
            "age": [
                1
            ],
            "yearsActive": [
                1
            ],
            "homeTown": [
                5
            ],
            "bloodType": [
                5
            ],
            "isFavourite": [
                4
            ],
            "isFavouriteBlocked": [
                4
            ],
            "siteUrl": [
                5
            ],
            "staffMedia": [
                21,
                {
                    "sort": [
                        42,
                        "[MediaSort]"
                    ],
                    "type": [
                        25
                    ],
                    "onList": [
                        4
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "characters": [
                37,
                {
                    "sort": [
                        35,
                        "[CharacterSort]"
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "characterMedia": [
                21,
                {
                    "sort": [
                        42,
                        "[MediaSort]"
                    ],
                    "onList": [
                        4
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "updatedAt": [
                1
            ],
            "staff": [
                45
            ],
            "submitter": [
                7
            ],
            "submissionStatus": [
                1
            ],
            "submissionNotes": [
                5
            ],
            "favourites": [
                1
            ],
            "modNotes": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "StaffName": {
            "first": [
                5
            ],
            "middle": [
                5
            ],
            "last": [
                5
            ],
            "full": [
                5
            ],
            "native": [
                5
            ],
            "alternative": [
                5
            ],
            "userPreferred": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "StaffImage": {
            "large": [
                5
            ],
            "medium": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "StaffRoleType": {
            "voiceActor": [
                45
            ],
            "roleNotes": [
                5
            ],
            "dubGroup": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "StaffConnection": {
            "edges": [
                50
            ],
            "nodes": [
                45
            ],
            "pageInfo": [
                3
            ],
            "__typename": [
                5
            ]
        },
        "StaffEdge": {
            "node": [
                45
            ],
            "id": [
                1
            ],
            "role": [
                5
            ],
            "favouriteOrder": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "StudioSort": {},
        "StudioConnection": {
            "edges": [
                53
            ],
            "nodes": [
                54
            ],
            "pageInfo": [
                3
            ],
            "__typename": [
                5
            ]
        },
        "StudioEdge": {
            "node": [
                54
            ],
            "id": [
                1
            ],
            "isMain": [
                4
            ],
            "favouriteOrder": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "Studio": {
            "id": [
                1
            ],
            "name": [
                5
            ],
            "isAnimationStudio": [
                4
            ],
            "media": [
                21,
                {
                    "sort": [
                        42,
                        "[MediaSort]"
                    ],
                    "isMain": [
                        4
                    ],
                    "onList": [
                        4
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "siteUrl": [
                5
            ],
            "isFavourite": [
                4
            ],
            "favourites": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "AiringSchedule": {
            "id": [
                1
            ],
            "airingAt": [
                1
            ],
            "timeUntilAiring": [
                1
            ],
            "episode": [
                1
            ],
            "mediaId": [
                1
            ],
            "media": [
                23
            ],
            "__typename": [
                5
            ]
        },
        "AiringScheduleConnection": {
            "edges": [
                57
            ],
            "nodes": [
                55
            ],
            "pageInfo": [
                3
            ],
            "__typename": [
                5
            ]
        },
        "AiringScheduleEdge": {
            "node": [
                55
            ],
            "id": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "MediaTrendSort": {},
        "MediaTrendConnection": {
            "edges": [
                60
            ],
            "nodes": [
                61
            ],
            "pageInfo": [
                3
            ],
            "__typename": [
                5
            ]
        },
        "MediaTrendEdge": {
            "node": [
                61
            ],
            "__typename": [
                5
            ]
        },
        "MediaTrend": {
            "mediaId": [
                1
            ],
            "date": [
                1
            ],
            "trending": [
                1
            ],
            "averageScore": [
                1
            ],
            "popularity": [
                1
            ],
            "inProgress": [
                1
            ],
            "releasing": [
                4
            ],
            "episode": [
                1
            ],
            "media": [
                23
            ],
            "__typename": [
                5
            ]
        },
        "MediaExternalLink": {
            "id": [
                1
            ],
            "url": [
                5
            ],
            "site": [
                5
            ],
            "siteId": [
                1
            ],
            "type": [
                63
            ],
            "language": [
                5
            ],
            "color": [
                5
            ],
            "icon": [
                5
            ],
            "notes": [
                5
            ],
            "isDisabled": [
                4
            ],
            "__typename": [
                5
            ]
        },
        "ExternalLinkType": {},
        "MediaStreamingEpisode": {
            "title": [
                5
            ],
            "thumbnail": [
                5
            ],
            "url": [
                5
            ],
            "site": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "MediaRank": {
            "id": [
                1
            ],
            "rank": [
                1
            ],
            "type": [
                66
            ],
            "format": [
                26
            ],
            "year": [
                1
            ],
            "season": [
                29
            ],
            "allTime": [
                4
            ],
            "context": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "MediaRankType": {},
        "MediaList": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "mediaId": [
                1
            ],
            "status": [
                16
            ],
            "score": [
                68,
                {
                    "format": [
                        18
                    ]
                }
            ],
            "progress": [
                1
            ],
            "progressVolumes": [
                1
            ],
            "repeat": [
                1
            ],
            "priority": [
                1
            ],
            "private": [
                4
            ],
            "notes": [
                5
            ],
            "hiddenFromStatusLists": [
                4
            ],
            "customLists": [
                9,
                {
                    "asArray": [
                        4
                    ]
                }
            ],
            "advancedScores": [
                9
            ],
            "startedAt": [
                28
            ],
            "completedAt": [
                28
            ],
            "updatedAt": [
                1
            ],
            "createdAt": [
                1
            ],
            "media": [
                23
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "Float": {},
        "ReviewSort": {},
        "ReviewConnection": {
            "edges": [
                71
            ],
            "nodes": [
                72
            ],
            "pageInfo": [
                3
            ],
            "__typename": [
                5
            ]
        },
        "ReviewEdge": {
            "node": [
                72
            ],
            "__typename": [
                5
            ]
        },
        "Review": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "mediaId": [
                1
            ],
            "mediaType": [
                25
            ],
            "summary": [
                5
            ],
            "body": [
                5,
                {
                    "asHtml": [
                        4
                    ]
                }
            ],
            "rating": [
                1
            ],
            "ratingAmount": [
                1
            ],
            "userRating": [
                73
            ],
            "score": [
                1
            ],
            "private": [
                4
            ],
            "siteUrl": [
                5
            ],
            "createdAt": [
                1
            ],
            "updatedAt": [
                1
            ],
            "user": [
                7
            ],
            "media": [
                23
            ],
            "__typename": [
                5
            ]
        },
        "ReviewRating": {},
        "RecommendationSort": {},
        "RecommendationConnection": {
            "edges": [
                76
            ],
            "nodes": [
                77
            ],
            "pageInfo": [
                3
            ],
            "__typename": [
                5
            ]
        },
        "RecommendationEdge": {
            "node": [
                77
            ],
            "__typename": [
                5
            ]
        },
        "Recommendation": {
            "id": [
                1
            ],
            "rating": [
                1
            ],
            "userRating": [
                78
            ],
            "media": [
                23
            ],
            "mediaRecommendation": [
                23
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "RecommendationRating": {},
        "MediaStats": {
            "scoreDistribution": [
                80
            ],
            "statusDistribution": [
                81
            ],
            "airingProgression": [
                82
            ],
            "__typename": [
                5
            ]
        },
        "ScoreDistribution": {
            "score": [
                1
            ],
            "amount": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "StatusDistribution": {
            "status": [
                16
            ],
            "amount": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "AiringProgression": {
            "episode": [
                68
            ],
            "score": [
                68
            ],
            "watching": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "MediaRelation": {},
        "UserStatisticTypes": {
            "anime": [
                85
            ],
            "manga": [
                85
            ],
            "__typename": [
                5
            ]
        },
        "UserStatistics": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "standardDeviation": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "episodesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "volumesRead": [
                1
            ],
            "formats": [
                87,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        86,
                        "[UserStatisticsSort]"
                    ]
                }
            ],
            "statuses": [
                88,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        86,
                        "[UserStatisticsSort]"
                    ]
                }
            ],
            "scores": [
                89,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        86,
                        "[UserStatisticsSort]"
                    ]
                }
            ],
            "lengths": [
                90,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        86,
                        "[UserStatisticsSort]"
                    ]
                }
            ],
            "releaseYears": [
                91,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        86,
                        "[UserStatisticsSort]"
                    ]
                }
            ],
            "startYears": [
                92,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        86,
                        "[UserStatisticsSort]"
                    ]
                }
            ],
            "genres": [
                93,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        86,
                        "[UserStatisticsSort]"
                    ]
                }
            ],
            "tags": [
                94,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        86,
                        "[UserStatisticsSort]"
                    ]
                }
            ],
            "countries": [
                95,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        86,
                        "[UserStatisticsSort]"
                    ]
                }
            ],
            "voiceActors": [
                96,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        86,
                        "[UserStatisticsSort]"
                    ]
                }
            ],
            "staff": [
                97,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        86,
                        "[UserStatisticsSort]"
                    ]
                }
            ],
            "studios": [
                98,
                {
                    "limit": [
                        1
                    ],
                    "sort": [
                        86,
                        "[UserStatisticsSort]"
                    ]
                }
            ],
            "__typename": [
                5
            ]
        },
        "UserStatisticsSort": {},
        "UserFormatStatistic": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "mediaIds": [
                1
            ],
            "format": [
                26
            ],
            "__typename": [
                5
            ]
        },
        "UserStatusStatistic": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "mediaIds": [
                1
            ],
            "status": [
                16
            ],
            "__typename": [
                5
            ]
        },
        "UserScoreStatistic": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "mediaIds": [
                1
            ],
            "score": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "UserLengthStatistic": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "mediaIds": [
                1
            ],
            "length": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "UserReleaseYearStatistic": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "mediaIds": [
                1
            ],
            "releaseYear": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "UserStartYearStatistic": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "mediaIds": [
                1
            ],
            "startYear": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "UserGenreStatistic": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "mediaIds": [
                1
            ],
            "genre": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "UserTagStatistic": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "mediaIds": [
                1
            ],
            "tag": [
                34
            ],
            "__typename": [
                5
            ]
        },
        "UserCountryStatistic": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "mediaIds": [
                1
            ],
            "country": [
                30
            ],
            "__typename": [
                5
            ]
        },
        "UserVoiceActorStatistic": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "mediaIds": [
                1
            ],
            "voiceActor": [
                45
            ],
            "characterIds": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "UserStaffStatistic": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "mediaIds": [
                1
            ],
            "staff": [
                45
            ],
            "__typename": [
                5
            ]
        },
        "UserStudioStatistic": {
            "count": [
                1
            ],
            "meanScore": [
                68
            ],
            "minutesWatched": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "mediaIds": [
                1
            ],
            "studio": [
                54
            ],
            "__typename": [
                5
            ]
        },
        "ModRole": {},
        "UserStats": {
            "watchedTime": [
                1
            ],
            "chaptersRead": [
                1
            ],
            "activityHistory": [
                101
            ],
            "animeStatusDistribution": [
                81
            ],
            "mangaStatusDistribution": [
                81
            ],
            "animeScoreDistribution": [
                80
            ],
            "mangaScoreDistribution": [
                80
            ],
            "animeListScores": [
                102
            ],
            "mangaListScores": [
                102
            ],
            "favouredGenresOverview": [
                103
            ],
            "favouredGenres": [
                103
            ],
            "favouredTags": [
                104
            ],
            "favouredActors": [
                105
            ],
            "favouredStaff": [
                105
            ],
            "favouredStudios": [
                106
            ],
            "favouredYears": [
                107
            ],
            "favouredFormats": [
                108
            ],
            "__typename": [
                5
            ]
        },
        "UserActivityHistory": {
            "date": [
                1
            ],
            "amount": [
                1
            ],
            "level": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "ListScoreStats": {
            "meanScore": [
                1
            ],
            "standardDeviation": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "GenreStats": {
            "genre": [
                5
            ],
            "amount": [
                1
            ],
            "meanScore": [
                1
            ],
            "timeWatched": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "TagStats": {
            "tag": [
                34
            ],
            "amount": [
                1
            ],
            "meanScore": [
                1
            ],
            "timeWatched": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "StaffStats": {
            "staff": [
                45
            ],
            "amount": [
                1
            ],
            "meanScore": [
                1
            ],
            "timeWatched": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "StudioStats": {
            "studio": [
                54
            ],
            "amount": [
                1
            ],
            "meanScore": [
                1
            ],
            "timeWatched": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "YearStats": {
            "year": [
                1
            ],
            "amount": [
                1
            ],
            "meanScore": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "FormatStats": {
            "format": [
                26
            ],
            "amount": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "UserPreviousName": {
            "name": [
                5
            ],
            "createdAt": [
                1
            ],
            "updatedAt": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "FuzzyDateInt": {},
        "MediaListSort": {},
        "AiringSort": {},
        "NotificationUnion": {
            "on_AiringNotification": [
                114
            ],
            "on_FollowingNotification": [
                115
            ],
            "on_ActivityMessageNotification": [
                116
            ],
            "on_ActivityMentionNotification": [
                120
            ],
            "on_ActivityReplyNotification": [
                124
            ],
            "on_ActivityReplySubscribedNotification": [
                125
            ],
            "on_ActivityLikeNotification": [
                126
            ],
            "on_ActivityReplyLikeNotification": [
                127
            ],
            "on_ThreadCommentMentionNotification": [
                128
            ],
            "on_ThreadCommentReplyNotification": [
                132
            ],
            "on_ThreadCommentSubscribedNotification": [
                133
            ],
            "on_ThreadCommentLikeNotification": [
                134
            ],
            "on_ThreadLikeNotification": [
                135
            ],
            "on_RelatedMediaAdditionNotification": [
                136
            ],
            "on_MediaDataChangeNotification": [
                137
            ],
            "on_MediaMergeNotification": [
                138
            ],
            "on_MediaDeletionNotification": [
                139
            ],
            "__typename": [
                5
            ]
        },
        "AiringNotification": {
            "id": [
                1
            ],
            "type": [
                13
            ],
            "animeId": [
                1
            ],
            "episode": [
                1
            ],
            "contexts": [
                5
            ],
            "createdAt": [
                1
            ],
            "media": [
                23
            ],
            "__typename": [
                5
            ]
        },
        "FollowingNotification": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                13
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ActivityMessageNotification": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                13
            ],
            "activityId": [
                1
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "message": [
                117
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "MessageActivity": {
            "id": [
                1
            ],
            "recipientId": [
                1
            ],
            "messengerId": [
                1
            ],
            "type": [
                118
            ],
            "replyCount": [
                1
            ],
            "message": [
                5,
                {
                    "asHtml": [
                        4
                    ]
                }
            ],
            "isLocked": [
                4
            ],
            "isSubscribed": [
                4
            ],
            "likeCount": [
                1
            ],
            "isLiked": [
                4
            ],
            "isPrivate": [
                4
            ],
            "siteUrl": [
                5
            ],
            "createdAt": [
                1
            ],
            "recipient": [
                7
            ],
            "messenger": [
                7
            ],
            "replies": [
                119
            ],
            "likes": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ActivityType": {},
        "ActivityReply": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "activityId": [
                1
            ],
            "text": [
                5,
                {
                    "asHtml": [
                        4
                    ]
                }
            ],
            "likeCount": [
                1
            ],
            "isLiked": [
                4
            ],
            "createdAt": [
                1
            ],
            "user": [
                7
            ],
            "likes": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ActivityMentionNotification": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                13
            ],
            "activityId": [
                1
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "activity": [
                121
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ActivityUnion": {
            "on_TextActivity": [
                122
            ],
            "on_ListActivity": [
                123
            ],
            "on_MessageActivity": [
                117
            ],
            "__typename": [
                5
            ]
        },
        "TextActivity": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                118
            ],
            "replyCount": [
                1
            ],
            "text": [
                5,
                {
                    "asHtml": [
                        4
                    ]
                }
            ],
            "siteUrl": [
                5
            ],
            "isLocked": [
                4
            ],
            "isSubscribed": [
                4
            ],
            "likeCount": [
                1
            ],
            "isLiked": [
                4
            ],
            "isPinned": [
                4
            ],
            "createdAt": [
                1
            ],
            "user": [
                7
            ],
            "replies": [
                119
            ],
            "likes": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ListActivity": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                118
            ],
            "replyCount": [
                1
            ],
            "status": [
                5
            ],
            "progress": [
                5
            ],
            "isLocked": [
                4
            ],
            "isSubscribed": [
                4
            ],
            "likeCount": [
                1
            ],
            "isLiked": [
                4
            ],
            "isPinned": [
                4
            ],
            "siteUrl": [
                5
            ],
            "createdAt": [
                1
            ],
            "user": [
                7
            ],
            "media": [
                23
            ],
            "replies": [
                119
            ],
            "likes": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ActivityReplyNotification": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                13
            ],
            "activityId": [
                1
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "activity": [
                121
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ActivityReplySubscribedNotification": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                13
            ],
            "activityId": [
                1
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "activity": [
                121
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ActivityLikeNotification": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                13
            ],
            "activityId": [
                1
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "activity": [
                121
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ActivityReplyLikeNotification": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                13
            ],
            "activityId": [
                1
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "activity": [
                121
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ThreadCommentMentionNotification": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                13
            ],
            "commentId": [
                1
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "thread": [
                129
            ],
            "comment": [
                131
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "Thread": {
            "id": [
                1
            ],
            "title": [
                5
            ],
            "body": [
                5,
                {
                    "asHtml": [
                        4
                    ]
                }
            ],
            "userId": [
                1
            ],
            "replyUserId": [
                1
            ],
            "replyCommentId": [
                1
            ],
            "replyCount": [
                1
            ],
            "viewCount": [
                1
            ],
            "isLocked": [
                4
            ],
            "isSticky": [
                4
            ],
            "isSubscribed": [
                4
            ],
            "likeCount": [
                1
            ],
            "isLiked": [
                4
            ],
            "repliedAt": [
                1
            ],
            "createdAt": [
                1
            ],
            "updatedAt": [
                1
            ],
            "user": [
                7
            ],
            "replyUser": [
                7
            ],
            "likes": [
                7
            ],
            "siteUrl": [
                5
            ],
            "categories": [
                130
            ],
            "mediaCategories": [
                23
            ],
            "__typename": [
                5
            ]
        },
        "ThreadCategory": {
            "id": [
                1
            ],
            "name": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "ThreadComment": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "threadId": [
                1
            ],
            "comment": [
                5,
                {
                    "asHtml": [
                        4
                    ]
                }
            ],
            "likeCount": [
                1
            ],
            "isLiked": [
                4
            ],
            "siteUrl": [
                5
            ],
            "createdAt": [
                1
            ],
            "updatedAt": [
                1
            ],
            "thread": [
                129
            ],
            "user": [
                7
            ],
            "likes": [
                7
            ],
            "childComments": [
                9
            ],
            "isLocked": [
                4
            ],
            "__typename": [
                5
            ]
        },
        "ThreadCommentReplyNotification": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                13
            ],
            "commentId": [
                1
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "thread": [
                129
            ],
            "comment": [
                131
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ThreadCommentSubscribedNotification": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                13
            ],
            "commentId": [
                1
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "thread": [
                129
            ],
            "comment": [
                131
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ThreadCommentLikeNotification": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                13
            ],
            "commentId": [
                1
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "thread": [
                129
            ],
            "comment": [
                131
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "ThreadLikeNotification": {
            "id": [
                1
            ],
            "userId": [
                1
            ],
            "type": [
                13
            ],
            "threadId": [
                1
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "thread": [
                129
            ],
            "comment": [
                131
            ],
            "user": [
                7
            ],
            "__typename": [
                5
            ]
        },
        "RelatedMediaAdditionNotification": {
            "id": [
                1
            ],
            "type": [
                13
            ],
            "mediaId": [
                1
            ],
            "context": [
                5
            ],
            "createdAt": [
                1
            ],
            "media": [
                23
            ],
            "__typename": [
                5
            ]
        },
        "MediaDataChangeNotification": {
            "id": [
                1
            ],
            "type": [
                13
            ],
            "mediaId": [
                1
            ],
            "context": [
                5
            ],
            "reason": [
                5
            ],
            "createdAt": [
                1
            ],
            "media": [
                23
            ],
            "__typename": [
                5
            ]
        },
        "MediaMergeNotification": {
            "id": [
                1
            ],
            "type": [
                13
            ],
            "mediaId": [
                1
            ],
            "deletedMediaTitles": [
                5
            ],
            "context": [
                5
            ],
            "reason": [
                5
            ],
            "createdAt": [
                1
            ],
            "media": [
                23
            ],
            "__typename": [
                5
            ]
        },
        "MediaDeletionNotification": {
            "id": [
                1
            ],
            "type": [
                13
            ],
            "deletedMediaTitle": [
                5
            ],
            "context": [
                5
            ],
            "reason": [
                5
            ],
            "createdAt": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "ActivitySort": {},
        "ThreadSort": {},
        "ThreadCommentSort": {},
        "LikeableType": {},
        "MediaListCollection": {
            "lists": [
                145
            ],
            "user": [
                7
            ],
            "hasNextChunk": [
                4
            ],
            "statusLists": [
                67,
                {
                    "asArray": [
                        4
                    ]
                }
            ],
            "customLists": [
                67,
                {
                    "asArray": [
                        4
                    ]
                }
            ],
            "__typename": [
                5
            ]
        },
        "MediaListGroup": {
            "entries": [
                67
            ],
            "name": [
                5
            ],
            "isCustomList": [
                4
            ],
            "isSplitCompletedList": [
                4
            ],
            "status": [
                16
            ],
            "__typename": [
                5
            ]
        },
        "ParsedMarkdown": {
            "html": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "AniChartUser": {
            "user": [
                7
            ],
            "settings": [
                9
            ],
            "highlights": [
                9
            ],
            "__typename": [
                5
            ]
        },
        "SiteStatistics": {
            "users": [
                150,
                {
                    "sort": [
                        149,
                        "[SiteTrendSort]"
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "anime": [
                150,
                {
                    "sort": [
                        149,
                        "[SiteTrendSort]"
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "manga": [
                150,
                {
                    "sort": [
                        149,
                        "[SiteTrendSort]"
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "characters": [
                150,
                {
                    "sort": [
                        149,
                        "[SiteTrendSort]"
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "staff": [
                150,
                {
                    "sort": [
                        149,
                        "[SiteTrendSort]"
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "studios": [
                150,
                {
                    "sort": [
                        149,
                        "[SiteTrendSort]"
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "reviews": [
                150,
                {
                    "sort": [
                        149,
                        "[SiteTrendSort]"
                    ],
                    "page": [
                        1
                    ],
                    "perPage": [
                        1
                    ]
                }
            ],
            "__typename": [
                5
            ]
        },
        "SiteTrendSort": {},
        "SiteTrendConnection": {
            "edges": [
                151
            ],
            "nodes": [
                152
            ],
            "pageInfo": [
                3
            ],
            "__typename": [
                5
            ]
        },
        "SiteTrendEdge": {
            "node": [
                152
            ],
            "__typename": [
                5
            ]
        },
        "SiteTrend": {
            "date": [
                1
            ],
            "count": [
                1
            ],
            "change": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "ExternalLinkMediaType": {},
        "Mutation": {
            "UpdateUser": [
                7,
                {
                    "about": [
                        5
                    ],
                    "titleLanguage": [
                        11
                    ],
                    "displayAdultContent": [
                        4
                    ],
                    "airingNotifications": [
                        4
                    ],
                    "scoreFormat": [
                        18
                    ],
                    "rowOrder": [
                        5
                    ],
                    "profileColor": [
                        5
                    ],
                    "donatorBadge": [
                        5
                    ],
                    "notificationOptions": [
                        155,
                        "[NotificationOptionInput]"
                    ],
                    "timezone": [
                        5
                    ],
                    "activityMergeTime": [
                        1
                    ],
                    "animeListOptions": [
                        156
                    ],
                    "mangaListOptions": [
                        156
                    ],
                    "staffNameLanguage": [
                        14
                    ],
                    "restrictMessagesToFollowing": [
                        4
                    ],
                    "disabledListActivity": [
                        157,
                        "[ListActivityOptionInput]"
                    ]
                }
            ],
            "SaveMediaListEntry": [
                67,
                {
                    "id": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "status": [
                        16
                    ],
                    "score": [
                        68
                    ],
                    "scoreRaw": [
                        1
                    ],
                    "progress": [
                        1
                    ],
                    "progressVolumes": [
                        1
                    ],
                    "repeat": [
                        1
                    ],
                    "priority": [
                        1
                    ],
                    "private": [
                        4
                    ],
                    "notes": [
                        5
                    ],
                    "hiddenFromStatusLists": [
                        4
                    ],
                    "customLists": [
                        5,
                        "[String]"
                    ],
                    "advancedScores": [
                        68,
                        "[Float]"
                    ],
                    "startedAt": [
                        158
                    ],
                    "completedAt": [
                        158
                    ]
                }
            ],
            "UpdateMediaListEntries": [
                67,
                {
                    "status": [
                        16
                    ],
                    "score": [
                        68
                    ],
                    "scoreRaw": [
                        1
                    ],
                    "progress": [
                        1
                    ],
                    "progressVolumes": [
                        1
                    ],
                    "repeat": [
                        1
                    ],
                    "priority": [
                        1
                    ],
                    "private": [
                        4
                    ],
                    "notes": [
                        5
                    ],
                    "hiddenFromStatusLists": [
                        4
                    ],
                    "advancedScores": [
                        68,
                        "[Float]"
                    ],
                    "startedAt": [
                        158
                    ],
                    "completedAt": [
                        158
                    ],
                    "ids": [
                        1,
                        "[Int]"
                    ]
                }
            ],
            "DeleteMediaListEntry": [
                159,
                {
                    "id": [
                        1
                    ]
                }
            ],
            "DeleteCustomList": [
                159,
                {
                    "customList": [
                        5
                    ],
                    "type": [
                        25
                    ]
                }
            ],
            "SaveTextActivity": [
                122,
                {
                    "id": [
                        1
                    ],
                    "text": [
                        5
                    ],
                    "locked": [
                        4
                    ]
                }
            ],
            "SaveMessageActivity": [
                117,
                {
                    "id": [
                        1
                    ],
                    "message": [
                        5
                    ],
                    "recipientId": [
                        1
                    ],
                    "private": [
                        4
                    ],
                    "locked": [
                        4
                    ],
                    "asMod": [
                        4
                    ]
                }
            ],
            "SaveListActivity": [
                123,
                {
                    "id": [
                        1
                    ],
                    "locked": [
                        4
                    ]
                }
            ],
            "DeleteActivity": [
                159,
                {
                    "id": [
                        1
                    ]
                }
            ],
            "ToggleActivityPin": [
                121,
                {
                    "id": [
                        1
                    ],
                    "pinned": [
                        4
                    ]
                }
            ],
            "ToggleActivitySubscription": [
                121,
                {
                    "activityId": [
                        1
                    ],
                    "subscribe": [
                        4
                    ]
                }
            ],
            "SaveActivityReply": [
                119,
                {
                    "id": [
                        1
                    ],
                    "activityId": [
                        1
                    ],
                    "text": [
                        5
                    ],
                    "asMod": [
                        4
                    ]
                }
            ],
            "DeleteActivityReply": [
                159,
                {
                    "id": [
                        1
                    ]
                }
            ],
            "ToggleLike": [
                7,
                {
                    "id": [
                        1
                    ],
                    "type": [
                        143
                    ]
                }
            ],
            "ToggleLikeV2": [
                160,
                {
                    "id": [
                        1
                    ],
                    "type": [
                        143
                    ]
                }
            ],
            "ToggleFollow": [
                7,
                {
                    "userId": [
                        1
                    ]
                }
            ],
            "ToggleFavourite": [
                20,
                {
                    "animeId": [
                        1
                    ],
                    "mangaId": [
                        1
                    ],
                    "characterId": [
                        1
                    ],
                    "staffId": [
                        1
                    ],
                    "studioId": [
                        1
                    ]
                }
            ],
            "UpdateFavouriteOrder": [
                20,
                {
                    "animeIds": [
                        1,
                        "[Int]"
                    ],
                    "mangaIds": [
                        1,
                        "[Int]"
                    ],
                    "characterIds": [
                        1,
                        "[Int]"
                    ],
                    "staffIds": [
                        1,
                        "[Int]"
                    ],
                    "studioIds": [
                        1,
                        "[Int]"
                    ],
                    "animeOrder": [
                        1,
                        "[Int]"
                    ],
                    "mangaOrder": [
                        1,
                        "[Int]"
                    ],
                    "characterOrder": [
                        1,
                        "[Int]"
                    ],
                    "staffOrder": [
                        1,
                        "[Int]"
                    ],
                    "studioOrder": [
                        1,
                        "[Int]"
                    ]
                }
            ],
            "SaveReview": [
                72,
                {
                    "id": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "body": [
                        5
                    ],
                    "summary": [
                        5
                    ],
                    "score": [
                        1
                    ],
                    "private": [
                        4
                    ]
                }
            ],
            "DeleteReview": [
                159,
                {
                    "id": [
                        1
                    ]
                }
            ],
            "RateReview": [
                72,
                {
                    "reviewId": [
                        1
                    ],
                    "rating": [
                        73
                    ]
                }
            ],
            "SaveRecommendation": [
                77,
                {
                    "mediaId": [
                        1
                    ],
                    "mediaRecommendationId": [
                        1
                    ],
                    "rating": [
                        78
                    ]
                }
            ],
            "SaveThread": [
                129,
                {
                    "id": [
                        1
                    ],
                    "title": [
                        5
                    ],
                    "body": [
                        5
                    ],
                    "categories": [
                        1,
                        "[Int]"
                    ],
                    "mediaCategories": [
                        1,
                        "[Int]"
                    ],
                    "sticky": [
                        4
                    ],
                    "locked": [
                        4
                    ]
                }
            ],
            "DeleteThread": [
                159,
                {
                    "id": [
                        1
                    ]
                }
            ],
            "ToggleThreadSubscription": [
                129,
                {
                    "threadId": [
                        1
                    ],
                    "subscribe": [
                        4
                    ]
                }
            ],
            "SaveThreadComment": [
                131,
                {
                    "id": [
                        1
                    ],
                    "threadId": [
                        1
                    ],
                    "parentCommentId": [
                        1
                    ],
                    "comment": [
                        5
                    ],
                    "locked": [
                        4
                    ]
                }
            ],
            "DeleteThreadComment": [
                159,
                {
                    "id": [
                        1
                    ]
                }
            ],
            "UpdateAniChartSettings": [
                9,
                {
                    "titleLanguage": [
                        5
                    ],
                    "outgoingLinkProvider": [
                        5
                    ],
                    "theme": [
                        5
                    ],
                    "sort": [
                        5
                    ]
                }
            ],
            "UpdateAniChartHighlights": [
                9,
                {
                    "highlights": [
                        161,
                        "[AniChartHighlightInput]"
                    ]
                }
            ],
            "__typename": [
                5
            ]
        },
        "NotificationOptionInput": {
            "type": [
                13
            ],
            "enabled": [
                4
            ],
            "__typename": [
                5
            ]
        },
        "MediaListOptionsInput": {
            "sectionOrder": [
                5
            ],
            "splitCompletedSectionByFormat": [
                4
            ],
            "customLists": [
                5
            ],
            "advancedScoring": [
                5
            ],
            "advancedScoringEnabled": [
                4
            ],
            "theme": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "ListActivityOptionInput": {
            "disabled": [
                4
            ],
            "type": [
                16
            ],
            "__typename": [
                5
            ]
        },
        "FuzzyDateInput": {
            "year": [
                1
            ],
            "month": [
                1
            ],
            "day": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "Deleted": {
            "deleted": [
                4
            ],
            "__typename": [
                5
            ]
        },
        "LikeableUnion": {
            "on_ListActivity": [
                123
            ],
            "on_TextActivity": [
                122
            ],
            "on_MessageActivity": [
                117
            ],
            "on_ActivityReply": [
                119
            ],
            "on_Thread": [
                129
            ],
            "on_ThreadComment": [
                131
            ],
            "__typename": [
                5
            ]
        },
        "AniChartHighlightInput": {
            "mediaId": [
                1
            ],
            "highlight": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "InternalPage": {
            "mediaSubmissions": [
                165,
                {
                    "mediaId": [
                        1
                    ],
                    "submissionId": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "assigneeId": [
                        1
                    ],
                    "status": [
                        163
                    ],
                    "type": [
                        25
                    ],
                    "sort": [
                        164,
                        "[SubmissionSort]"
                    ]
                }
            ],
            "characterSubmissions": [
                169,
                {
                    "characterId": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "assigneeId": [
                        1
                    ],
                    "status": [
                        163
                    ],
                    "sort": [
                        164,
                        "[SubmissionSort]"
                    ]
                }
            ],
            "staffSubmissions": [
                170,
                {
                    "staffId": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "assigneeId": [
                        1
                    ],
                    "status": [
                        163
                    ],
                    "sort": [
                        164,
                        "[SubmissionSort]"
                    ]
                }
            ],
            "revisionHistory": [
                171,
                {
                    "userId": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "characterId": [
                        1
                    ],
                    "staffId": [
                        1
                    ],
                    "studioId": [
                        1
                    ]
                }
            ],
            "reports": [
                173,
                {
                    "reporterId": [
                        1
                    ],
                    "reportedId": [
                        1
                    ]
                }
            ],
            "modActions": [
                174,
                {
                    "userId": [
                        1
                    ],
                    "modId": [
                        1
                    ]
                }
            ],
            "userBlockSearch": [
                7,
                {
                    "search": [
                        5
                    ]
                }
            ],
            "pageInfo": [
                3
            ],
            "users": [
                7,
                {
                    "id": [
                        1
                    ],
                    "name": [
                        5
                    ],
                    "isModerator": [
                        4
                    ],
                    "search": [
                        5
                    ],
                    "sort": [
                        6,
                        "[UserSort]"
                    ]
                }
            ],
            "media": [
                23,
                {
                    "id": [
                        1
                    ],
                    "idMal": [
                        1
                    ],
                    "startDate": [
                        110
                    ],
                    "endDate": [
                        110
                    ],
                    "season": [
                        29
                    ],
                    "seasonYear": [
                        1
                    ],
                    "type": [
                        25
                    ],
                    "format": [
                        26
                    ],
                    "status": [
                        27
                    ],
                    "episodes": [
                        1
                    ],
                    "duration": [
                        1
                    ],
                    "chapters": [
                        1
                    ],
                    "volumes": [
                        1
                    ],
                    "isAdult": [
                        4
                    ],
                    "genre": [
                        5
                    ],
                    "tag": [
                        5
                    ],
                    "minimumTagRank": [
                        1
                    ],
                    "tagCategory": [
                        5
                    ],
                    "onList": [
                        4
                    ],
                    "licensedBy": [
                        5
                    ],
                    "licensedById": [
                        1
                    ],
                    "averageScore": [
                        1
                    ],
                    "popularity": [
                        1
                    ],
                    "source": [
                        31
                    ],
                    "countryOfOrigin": [
                        30
                    ],
                    "isLicensed": [
                        4
                    ],
                    "search": [
                        5
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "idMal_not": [
                        1
                    ],
                    "idMal_in": [
                        1,
                        "[Int]"
                    ],
                    "idMal_not_in": [
                        1,
                        "[Int]"
                    ],
                    "startDate_greater": [
                        110
                    ],
                    "startDate_lesser": [
                        110
                    ],
                    "startDate_like": [
                        5
                    ],
                    "endDate_greater": [
                        110
                    ],
                    "endDate_lesser": [
                        110
                    ],
                    "endDate_like": [
                        5
                    ],
                    "format_in": [
                        26,
                        "[MediaFormat]"
                    ],
                    "format_not": [
                        26
                    ],
                    "format_not_in": [
                        26,
                        "[MediaFormat]"
                    ],
                    "status_in": [
                        27,
                        "[MediaStatus]"
                    ],
                    "status_not": [
                        27
                    ],
                    "status_not_in": [
                        27,
                        "[MediaStatus]"
                    ],
                    "episodes_greater": [
                        1
                    ],
                    "episodes_lesser": [
                        1
                    ],
                    "duration_greater": [
                        1
                    ],
                    "duration_lesser": [
                        1
                    ],
                    "chapters_greater": [
                        1
                    ],
                    "chapters_lesser": [
                        1
                    ],
                    "volumes_greater": [
                        1
                    ],
                    "volumes_lesser": [
                        1
                    ],
                    "genre_in": [
                        5,
                        "[String]"
                    ],
                    "genre_not_in": [
                        5,
                        "[String]"
                    ],
                    "tag_in": [
                        5,
                        "[String]"
                    ],
                    "tag_not_in": [
                        5,
                        "[String]"
                    ],
                    "tagCategory_in": [
                        5,
                        "[String]"
                    ],
                    "tagCategory_not_in": [
                        5,
                        "[String]"
                    ],
                    "licensedBy_in": [
                        5,
                        "[String]"
                    ],
                    "licensedById_in": [
                        1,
                        "[Int]"
                    ],
                    "averageScore_not": [
                        1
                    ],
                    "averageScore_greater": [
                        1
                    ],
                    "averageScore_lesser": [
                        1
                    ],
                    "popularity_not": [
                        1
                    ],
                    "popularity_greater": [
                        1
                    ],
                    "popularity_lesser": [
                        1
                    ],
                    "source_in": [
                        31,
                        "[MediaSource]"
                    ],
                    "sort": [
                        42,
                        "[MediaSort]"
                    ]
                }
            ],
            "characters": [
                39,
                {
                    "id": [
                        1
                    ],
                    "isBirthday": [
                        4
                    ],
                    "search": [
                        5
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "sort": [
                        35,
                        "[CharacterSort]"
                    ]
                }
            ],
            "staff": [
                45,
                {
                    "id": [
                        1
                    ],
                    "isBirthday": [
                        4
                    ],
                    "search": [
                        5
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "sort": [
                        44,
                        "[StaffSort]"
                    ]
                }
            ],
            "studios": [
                54,
                {
                    "id": [
                        1
                    ],
                    "search": [
                        5
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "sort": [
                        51,
                        "[StudioSort]"
                    ]
                }
            ],
            "mediaList": [
                67,
                {
                    "id": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "userName": [
                        5
                    ],
                    "type": [
                        25
                    ],
                    "status": [
                        16
                    ],
                    "mediaId": [
                        1
                    ],
                    "isFollowing": [
                        4
                    ],
                    "notes": [
                        5
                    ],
                    "startedAt": [
                        110
                    ],
                    "completedAt": [
                        110
                    ],
                    "compareWithAuthList": [
                        4
                    ],
                    "userId_in": [
                        1,
                        "[Int]"
                    ],
                    "status_in": [
                        16,
                        "[MediaListStatus]"
                    ],
                    "status_not_in": [
                        16,
                        "[MediaListStatus]"
                    ],
                    "status_not": [
                        16
                    ],
                    "mediaId_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "notes_like": [
                        5
                    ],
                    "startedAt_greater": [
                        110
                    ],
                    "startedAt_lesser": [
                        110
                    ],
                    "startedAt_like": [
                        5
                    ],
                    "completedAt_greater": [
                        110
                    ],
                    "completedAt_lesser": [
                        110
                    ],
                    "completedAt_like": [
                        5
                    ],
                    "sort": [
                        111,
                        "[MediaListSort]"
                    ]
                }
            ],
            "airingSchedules": [
                55,
                {
                    "id": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "episode": [
                        1
                    ],
                    "airingAt": [
                        1
                    ],
                    "notYetAired": [
                        4
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not": [
                        1
                    ],
                    "mediaId_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "episode_not": [
                        1
                    ],
                    "episode_in": [
                        1,
                        "[Int]"
                    ],
                    "episode_not_in": [
                        1,
                        "[Int]"
                    ],
                    "episode_greater": [
                        1
                    ],
                    "episode_lesser": [
                        1
                    ],
                    "airingAt_greater": [
                        1
                    ],
                    "airingAt_lesser": [
                        1
                    ],
                    "sort": [
                        112,
                        "[AiringSort]"
                    ]
                }
            ],
            "mediaTrends": [
                61,
                {
                    "mediaId": [
                        1
                    ],
                    "date": [
                        1
                    ],
                    "trending": [
                        1
                    ],
                    "averageScore": [
                        1
                    ],
                    "popularity": [
                        1
                    ],
                    "episode": [
                        1
                    ],
                    "releasing": [
                        4
                    ],
                    "mediaId_not": [
                        1
                    ],
                    "mediaId_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "date_greater": [
                        1
                    ],
                    "date_lesser": [
                        1
                    ],
                    "trending_greater": [
                        1
                    ],
                    "trending_lesser": [
                        1
                    ],
                    "trending_not": [
                        1
                    ],
                    "averageScore_greater": [
                        1
                    ],
                    "averageScore_lesser": [
                        1
                    ],
                    "averageScore_not": [
                        1
                    ],
                    "popularity_greater": [
                        1
                    ],
                    "popularity_lesser": [
                        1
                    ],
                    "popularity_not": [
                        1
                    ],
                    "episode_greater": [
                        1
                    ],
                    "episode_lesser": [
                        1
                    ],
                    "episode_not": [
                        1
                    ],
                    "sort": [
                        58,
                        "[MediaTrendSort]"
                    ]
                }
            ],
            "notifications": [
                113,
                {
                    "type": [
                        13
                    ],
                    "resetNotificationCount": [
                        4
                    ],
                    "type_in": [
                        13,
                        "[NotificationType]"
                    ]
                }
            ],
            "followers": [
                7,
                {
                    "userId": [
                        1,
                        "Int!"
                    ],
                    "sort": [
                        6,
                        "[UserSort]"
                    ]
                }
            ],
            "following": [
                7,
                {
                    "userId": [
                        1,
                        "Int!"
                    ],
                    "sort": [
                        6,
                        "[UserSort]"
                    ]
                }
            ],
            "activities": [
                121,
                {
                    "id": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "messengerId": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "type": [
                        118
                    ],
                    "isFollowing": [
                        4
                    ],
                    "hasReplies": [
                        4
                    ],
                    "hasRepliesOrTypeText": [
                        4
                    ],
                    "createdAt": [
                        1
                    ],
                    "id_not": [
                        1
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "id_not_in": [
                        1,
                        "[Int]"
                    ],
                    "userId_not": [
                        1
                    ],
                    "userId_in": [
                        1,
                        "[Int]"
                    ],
                    "userId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "messengerId_not": [
                        1
                    ],
                    "messengerId_in": [
                        1,
                        "[Int]"
                    ],
                    "messengerId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not": [
                        1
                    ],
                    "mediaId_in": [
                        1,
                        "[Int]"
                    ],
                    "mediaId_not_in": [
                        1,
                        "[Int]"
                    ],
                    "type_not": [
                        118
                    ],
                    "type_in": [
                        118,
                        "[ActivityType]"
                    ],
                    "type_not_in": [
                        118,
                        "[ActivityType]"
                    ],
                    "createdAt_greater": [
                        1
                    ],
                    "createdAt_lesser": [
                        1
                    ],
                    "sort": [
                        140,
                        "[ActivitySort]"
                    ]
                }
            ],
            "activityReplies": [
                119,
                {
                    "id": [
                        1
                    ],
                    "activityId": [
                        1
                    ]
                }
            ],
            "threads": [
                129,
                {
                    "id": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "replyUserId": [
                        1
                    ],
                    "subscribed": [
                        4
                    ],
                    "categoryId": [
                        1
                    ],
                    "mediaCategoryId": [
                        1
                    ],
                    "search": [
                        5
                    ],
                    "id_in": [
                        1,
                        "[Int]"
                    ],
                    "sort": [
                        141,
                        "[ThreadSort]"
                    ]
                }
            ],
            "threadComments": [
                131,
                {
                    "id": [
                        1
                    ],
                    "threadId": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "sort": [
                        142,
                        "[ThreadCommentSort]"
                    ]
                }
            ],
            "reviews": [
                72,
                {
                    "id": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "mediaType": [
                        25
                    ],
                    "sort": [
                        69,
                        "[ReviewSort]"
                    ]
                }
            ],
            "recommendations": [
                77,
                {
                    "id": [
                        1
                    ],
                    "mediaId": [
                        1
                    ],
                    "mediaRecommendationId": [
                        1
                    ],
                    "userId": [
                        1
                    ],
                    "rating": [
                        1
                    ],
                    "onList": [
                        4
                    ],
                    "rating_greater": [
                        1
                    ],
                    "rating_lesser": [
                        1
                    ],
                    "sort": [
                        74,
                        "[RecommendationSort]"
                    ]
                }
            ],
            "likes": [
                7,
                {
                    "likeableId": [
                        1
                    ],
                    "type": [
                        143
                    ]
                }
            ],
            "__typename": [
                5
            ]
        },
        "SubmissionStatus": {},
        "SubmissionSort": {},
        "MediaSubmission": {
            "id": [
                1
            ],
            "submitter": [
                7
            ],
            "assignee": [
                7
            ],
            "status": [
                163
            ],
            "submitterStats": [
                9
            ],
            "notes": [
                5
            ],
            "source": [
                5
            ],
            "changes": [
                5
            ],
            "locked": [
                4
            ],
            "media": [
                23
            ],
            "submission": [
                23
            ],
            "characters": [
                166
            ],
            "staff": [
                166
            ],
            "studios": [
                166
            ],
            "relations": [
                22
            ],
            "externalLinks": [
                166
            ],
            "createdAt": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "MediaSubmissionComparison": {
            "submission": [
                167
            ],
            "character": [
                168
            ],
            "staff": [
                50
            ],
            "studio": [
                53
            ],
            "externalLink": [
                62
            ],
            "__typename": [
                5
            ]
        },
        "MediaSubmissionEdge": {
            "id": [
                1
            ],
            "characterRole": [
                36
            ],
            "staffRole": [
                5
            ],
            "roleNotes": [
                5
            ],
            "dubGroup": [
                5
            ],
            "characterName": [
                5
            ],
            "isMain": [
                4
            ],
            "character": [
                39
            ],
            "characterSubmission": [
                39
            ],
            "voiceActor": [
                45
            ],
            "voiceActorSubmission": [
                45
            ],
            "staff": [
                45
            ],
            "staffSubmission": [
                45
            ],
            "studio": [
                54
            ],
            "externalLink": [
                62
            ],
            "media": [
                23
            ],
            "__typename": [
                5
            ]
        },
        "MediaCharacter": {
            "id": [
                1
            ],
            "role": [
                36
            ],
            "roleNotes": [
                5
            ],
            "dubGroup": [
                5
            ],
            "characterName": [
                5
            ],
            "character": [
                39
            ],
            "voiceActor": [
                45
            ],
            "__typename": [
                5
            ]
        },
        "CharacterSubmission": {
            "id": [
                1
            ],
            "character": [
                39
            ],
            "submission": [
                39
            ],
            "submitter": [
                7
            ],
            "assignee": [
                7
            ],
            "status": [
                163
            ],
            "notes": [
                5
            ],
            "source": [
                5
            ],
            "locked": [
                4
            ],
            "createdAt": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "StaffSubmission": {
            "id": [
                1
            ],
            "staff": [
                45
            ],
            "submission": [
                45
            ],
            "submitter": [
                7
            ],
            "assignee": [
                7
            ],
            "status": [
                163
            ],
            "notes": [
                5
            ],
            "source": [
                5
            ],
            "locked": [
                4
            ],
            "createdAt": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "RevisionHistory": {
            "id": [
                1
            ],
            "action": [
                172
            ],
            "changes": [
                9
            ],
            "user": [
                7
            ],
            "media": [
                23
            ],
            "character": [
                39
            ],
            "staff": [
                45
            ],
            "studio": [
                54
            ],
            "externalLink": [
                62
            ],
            "createdAt": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "RevisionHistoryAction": {},
        "Report": {
            "id": [
                1
            ],
            "reporter": [
                7
            ],
            "reported": [
                7
            ],
            "reason": [
                5
            ],
            "createdAt": [
                1
            ],
            "cleared": [
                4
            ],
            "__typename": [
                5
            ]
        },
        "ModAction": {
            "id": [
                1
            ],
            "user": [
                7
            ],
            "mod": [
                7
            ],
            "type": [
                175
            ],
            "objectId": [
                1
            ],
            "objectType": [
                5
            ],
            "data": [
                5
            ],
            "createdAt": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "ModActionType": {},
        "MediaTitleInput": {
            "romaji": [
                5
            ],
            "english": [
                5
            ],
            "native": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "AiringScheduleInput": {
            "airingAt": [
                1
            ],
            "episode": [
                1
            ],
            "timeUntilAiring": [
                1
            ],
            "__typename": [
                5
            ]
        },
        "MediaExternalLinkInput": {
            "id": [
                1
            ],
            "url": [
                5
            ],
            "site": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "CharacterNameInput": {
            "first": [
                5
            ],
            "middle": [
                5
            ],
            "last": [
                5
            ],
            "native": [
                5
            ],
            "alternative": [
                5
            ],
            "alternativeSpoiler": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "CharacterSubmissionConnection": {
            "edges": [
                181
            ],
            "nodes": [
                169
            ],
            "pageInfo": [
                3
            ],
            "__typename": [
                5
            ]
        },
        "CharacterSubmissionEdge": {
            "node": [
                169
            ],
            "role": [
                36
            ],
            "voiceActors": [
                45
            ],
            "submittedVoiceActors": [
                170
            ],
            "__typename": [
                5
            ]
        },
        "StaffNameInput": {
            "first": [
                5
            ],
            "middle": [
                5
            ],
            "last": [
                5
            ],
            "native": [
                5
            ],
            "alternative": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "UserModData": {
            "alts": [
                7
            ],
            "bans": [
                9
            ],
            "ip": [
                9
            ],
            "counts": [
                9
            ],
            "privacy": [
                1
            ],
            "email": [
                5
            ],
            "__typename": [
                5
            ]
        },
        "ID": {}
    }
}